*.loader,.context.loader,.ad.hoc.loader{background:#9e9ca5}*.overlay,.context.overlay,.ad.hoc.overlay{background:rgba(255,255,255,.5);pointer-events:all}